angular.module('ResearchKitApplicationModule').factory('platformCompatibilityService', function () {
	var supportedAndroidSteps = [
        "CelebrationStep",
        "CompletionStep",
        "ConnectDeviceAccountStep",
        "ConnectEhrStep",
        "ConsentReviewStep",
        "ConsentStep",
        "CountdownStep",
        "EndOfSurveyStep",
        "FormStep",
        "InstructionStep",
        "QuestionStep",
        "VideoInstructionStep",
        "VisualConsentStep",
        "WebViewStep",
        "YouTubeStep",
    ];
    var supportedWebSteps = [
        "CelebrationStep",
        "CompletionStep",
        "ConnectDeviceAccountStep",
        "ConnectEhrStep",
        "ConsentReviewStep",
        "ConsentStep",
        "CountdownStep",
        "EndOfSurveyStep",
        "FormStep",
        "ImageCaptureStep",
        "InstructionStep",
        "QuestionStep",
        "VideoInstructionStep",
        "VisualConsentStep",
        "WaitStep",
        "WebViewStep",
        "YouTubeStep",
    ];

	function getPlatforms(template) {
		if (!template) { return []; }

		if (template.type !== "RKStudioOrderedTask" && template.type !== "RKStudioNavigableOrderedTask") {
			return ["iOS"];
		}

		var platforms = ["iOS", "Android", "Web"];
		if (template.steps) {
			for (var i = 0; i < template.steps.length; i++) {
				if (supportedAndroidSteps.indexOf(template.steps[i].type) === -1) {
					platforms = _.without(platforms, "Android");
				}

				if (supportedWebSteps.indexOf(template.steps[i].type) === -1) {
					platforms = _.without(platforms, "Web");
				}
			}
		}

		return platforms;
	}

	return {
		getPlatforms: getPlatforms
	};
});